import React, { useState, useRef } from "react";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import "./Styles.css";

const testimonials = [
  {
    id: 1,
    name: 'Sis Joanna',
    title: 'Church Member',
    content: 'I glorify God for His miraculous healing. During the 5:30 a.m. FCC prayer, Pastor Sir, led by the Holy Spirit, called out my exact condition, prayed for me, and I received instant healing from severe shoulder pain. Hallelujah!',
    image: 'https://i.pravatar.cc/60?img=5'
  },
  {
    id: 2,
    name: 'Sis Shoma',
    title: 'Church Member',
    content: 'I thank God for His divine protection. While unloading a heavy glass panel that suddenly broke, everyone around me was injured and bleeding, but I was completely unharmed—not even a scratch. I give all the glory to God, knowing that His Word in Psalm 91 went ahead of me to protect me. Hallelujah!',
    image: 'https://i.pravatar.cc/60?img=9'
  },
  {
    id: 3,
    name: 'Bro. Joshua Bansode',
    title: 'Church Member',
    content: 'I thank God for the opportunity to attend Staff Week and ICLC in Lagos, where the Holy Spirit highlighted me and I had the privilege of sharing my testimony from the same podium where our Man of God ministered. On my return journey, I was led to preach to a fellow passenger on the flight and had the joy of leading him to Christ. Glory to God!',
    image: 'https://i.pravatar.cc/60?img=11'
  }
];

const TestimonialSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState(0);
  const [dragDelta, setDragDelta] = useState(0);
  const trackRef = useRef(null);

  const [headingRef, headingVisible] = useScrollAnimation({ threshold: 0.2 });
  const [carouselRef, carouselVisible] = useScrollAnimation({ threshold: 0.1 });

  const [visibleItems, setVisibleItems] = React.useState(3);

  React.useEffect(() => {
    const update = () => {
      if (window.innerWidth <= 640) setVisibleItems(1);
      else if (window.innerWidth <= 1024) setVisibleItems(2);
      else setVisibleItems(3);
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  const maxIndex = Math.max(0, testimonials.length - visibleItems);

  const goTo = (index) => setCurrentIndex(Math.min(Math.max(index, 0), maxIndex));
  const goLeft = () => goTo(currentIndex - 1);
  const goRight = () => goTo(currentIndex + 1);

  /* Touch / drag */
  const onTouchStart = (e) => {
    setDragStart(e.touches[0].clientX);
    setDragDelta(0);
    setIsDragging(true);
  };
  const onTouchMove = (e) => {
    if (!isDragging) return;
    setDragDelta(e.touches[0].clientX - dragStart);
  };
  const onTouchEnd = () => {
    if (Math.abs(dragDelta) > 50) {
      dragDelta < 0 ? goRight() : goLeft();
    }
    setIsDragging(false);
    setDragDelta(0);
  };

  /* Mouse drag */
  const onMouseDown = (e) => {
    setDragStart(e.clientX);
    setDragDelta(0);
    setIsDragging(true);
  };
  const onMouseMove = (e) => {
    if (!isDragging) return;
    setDragDelta(e.clientX - dragStart);
  };
  const onMouseUp = () => {
    if (Math.abs(dragDelta) > 50) {
      dragDelta < 0 ? goRight() : goLeft();
    }
    setIsDragging(false);
    setDragDelta(0);
  };

  /* Translate: each card is 100/visibleItems % wide */
  const cardPct = 100 / visibleItems;
  const translateX = -(currentIndex * cardPct) + (isDragging ? (dragDelta / (trackRef.current?.offsetWidth || 1)) * 100 : 0);

  return (
    <section className="testimonial">
      <div className="container">

        {/* HEADER — flip pattern: title LEFT, eyebrow RIGHT  (img1 pattern) */}
        <div
          ref={headingRef}
          className={`section-header section-header--flip fade-in-up ${headingVisible ? 'visible' : ''}`}
        >
          <div className="sh-title">
            <h2 className="section-title">
              TOGETHER, WE TAKE GOD'S GLORY TO THE NATIONS
            </h2>
            <div className="t-arrows">
              <button className="t-arrow" onClick={goLeft} disabled={currentIndex === 0} aria-label="Previous">&#8592;</button>
              <button className="t-arrow" onClick={goRight} disabled={currentIndex >= maxIndex} aria-label="Next">&#8594;</button>
            </div>
          </div>
          <div className="sh-label">
            <span className="eyebrow">Testimonials</span>
          </div>
        </div>

        {/* Carousel */}
        <div
          ref={carouselRef}
          className={`t-carousel scale-in ${carouselVisible ? 'visible' : ''}`}
        >
          <div
            ref={trackRef}
            className="t-track"
            style={{
              transform: `translateX(${translateX}%)`,
              transition: isDragging ? 'none' : 'transform 0.45s var(--ease-out)',
              cursor: isDragging ? 'grabbing' : 'grab',
            }}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
            onMouseLeave={onMouseUp}
          >
            {testimonials.map((t) => (
              <div
                className="t-card"
                key={t.id}
                style={{ flex: `0 0 calc(${cardPct}% - 16px)` }}
              >
                <div className="t-card-inner">
                  <div className="t-top">
                    <div className="t-quote">"</div>
                  </div>
                  <p className="t-text">{t.content}</p>
                  <div className="t-footer">
                    <div className="t-line" />
                    <div>
                      <p className="t-name">{t.name}</p>
                      {t.title && <p className="t-role">{t.title}</p>}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Dot indicators */}
        <div className="t-dots">
          {Array.from({ length: maxIndex + 1 }).map((_, i) => (
            <button
              key={i}
              className={`t-dot ${currentIndex === i ? 'active' : ''}`}
              onClick={() => goTo(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSlider;
